import { Address } from "@/models";

export class AddressCardModel {
  constructor(
    public name: string = '',
    public number: string = '',
    public address: Address = new Address()) {
  }

  loadFromSite(site: any) {
    this.name = site.siteName;
    this.number = site.siteNumber;
    this.address.loadFrom(site.streetAddress);
  }

  loadFromSponsor(sponsor: any) {
    this.name = sponsor.sponsorName;
    this.number = sponsor.sponsorNumber;
    this.address.loadFrom(sponsor.streetAddress);
  }

  clear() {
    this.name = '';
    this.number = '';
    if (this.address) {
      this.address.clear();
    }
  }
}
